import { useState } from "react";
import Sidebar from "./sidebar";
import Navbar from "./navbar";
import logo from '../assets/images/SHTATO LOGO.jpg';

const Profile = () => {
    const [user] = useState({
        fullName: "Shtatto Booking",
        email: "admin@gmail.com",
        phone: "+212 524375538",
        profilePic: logo,
    });

    const [previewImage] = useState(user.profilePic);

    return (
        <div className="min-h-screen flex bg-white">
            <div className="fixed lg:relative lg:flex">
                <Sidebar />
            </div>
            <div className="flex-1">
                <Navbar />
                <div className="flex-1 ml-0 lg:ml-64 px-32 py-10">
                    <h2 className="text-3xl font-bold text-center text-[#610c63] mb-6">Profile</h2>

                    <div className="flex flex-col items-center mb-8">
                        <img
                            src={previewImage}
                            alt="Profile"
                            className="w-32 h-32 rounded-full object-contain border-4 border-[#610c63]"
                        />
                        <p className="text-sm text-gray-500 mt-2">Profile Picture</p>
                    </div>

                    <div className="bg-[#f8f8f8] shadow-lg rounded-lg p-6 space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-[#610c63]">Full Name</label>
                            <p className="mt-1 text-gray-900 text-lg">{user.fullName}</p>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-[#610c63]">Email</label>
                            <p className="mt-1 text-gray-900 text-lg">{user.email}</p>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-[#610c63]">Phone</label>
                            <p className="mt-1 text-gray-900 text-lg">{user.phone}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
